/**
 * FIXME: Testing Portals is not well supported at this time. Since there is
 * minimal logic in this component coverage reporting has been ignored.
 */
/* istanbul ignore file */

import PropTypes from 'prop-types';
import React, { createContext, Component } from 'react';
import { createPortal } from 'react-dom';

import Body from './Body';
import Content from './Content';
import Footer from './Footer';
import Header from './Header';
import HeaderIcon from './HeaderIcon';
import Overlay from './Overlay';

function modalRoot() {
  return document.getElementById('modal-root');
}

const { Provider, Consumer } = createContext();

class Modal extends Component {
  static Body = Body;
  static Header = Header;
  static HeaderIcon = HeaderIcon;
  static Footer = Footer;
  static Content = Content;

  static propTypes = {
    children: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    modalRoot().appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot().removeChild(this.el);
  }

  // TODO: At some point we may want additional logic here,
  // say, to allow clicking the Overlay to close the modal
  // with strange bubbling side effects.
  closeModal = this.props.onClose;

  // To prevent re-renders, hat tip to Kent C. Dodds
  // Weird catch, state definition must be after function definition.
  // eslint-disable-next-line react/sort-comp
  state = {
    // eslint-disable-next-line react/no-unused-state
    closeModal: this.closeModal,
  };

  render() {
    const { onClose, ...rest } = this.props;

    return createPortal(
      <Provider value={this.state}>
        <Overlay {...rest}>{this.props.children(this.state)}</Overlay>
      </Provider>,
      this.el,
    );
  }
}

export { Consumer };
export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js